import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Nav, NavItem, Row, Col, Label } from 'react-bootstrap';
import Card from '../../common/components/Card';
import { loadSelfAssessments } from './actions';
import { withNamespaces } from 'react-i18next';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { createChild, CHILD_CREATE_REQUEST, CHILD_CREATE_SUCCESS, CHILD_CREATE_FAILURE } from '../actions';
import AddChildButton from '../children/AddChildButton';
import { hasSameAsParentChild } from '../reducer';

class SelfAssessments extends Component {
    constructor(props) {
        super(props);
        this.handleChildSelect = this.handleChildSelect.bind(this);
        this.handleAddChild = this.handleAddChild.bind(this);

        const firstChild = props.children && props.children[0];
        this.state = {
            selectedChildId: props.childId || (firstChild && firstChild.id),
        };
    }

    componentDidMount() {
        this.props.loadSelfAssessments();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.childId && (!this.props.children || this.props.children.length == 0) && nextProps.children && nextProps.children.length > 0) {
            this.handleChildSelect(nextProps.children[0].id);
        }
    }

    handleChildSelect(childId) {
        this.setState({ selectedChildId: childId });
        this.props.history.replace(`/self-assessments/${childId}`);
    }

    handleAddChild(values, onSuccess) {
        this.props.createChild(values, null, onSuccess);
    }

    mapStatusStyle(status) {
        let color = '';
        let icon = '';

        switch (status) {
            case 'New':
                color = 'danger';
                icon = 'times';
                break;
            case 'Draft':
                color = 'warning';
                icon = 'edit';
                break;
            case 'Final':
                color = 'success';
                icon = 'check';
                break;
        }

        return { color, icon };
    }

    render() {
        const { children, selfAssessments, selfAssessmentForms, requireChildLastName, enableParentSelfBooking, hasSameAsParentChild, t } = this.props;

        if (!children || children.length == 0) {
            return <AddChildButton requireChildLastName={requireChildLastName} enableParentSelfBooking={enableParentSelfBooking}
                hasSameAsParentChild={hasSameAsParentChild}
                onConfirm={this.handleAddChild} block={CHILD_CREATE_REQUEST} unblock={[CHILD_CREATE_SUCCESS, CHILD_CREATE_FAILURE]} />;
        }

        const { selectedChildId } = this.state;
        const childSelfAssessments = selfAssessments.filter(x => x.childId === selectedChildId);
        selfAssessmentForms && selfAssessmentForms.filter(x => !childSelfAssessments.find(t => t.formId === x.id))
            .forEach(form => childSelfAssessments.push({ id: 0, formId: form.id, name: form.name, status: 'New' }));

        return <div>
            {children.length > 1 ? <Nav id='children' bsStyle='pills' style={{ marginBottom: 10 }} activeKey={selectedChildId} onSelect={this.handleChildSelect}>
                {children.map(x => <NavItem key={x.id} eventKey={x.id} title={x.fullName}>
                    {x.fullName}
                </NavItem>)}
            </Nav> : <h3>{children[0].fullName}</h3>}
            <Row>
                {childSelfAssessments.map(item => {
                    const { color, icon } = this.mapStatusStyle(item.status);
                    return <Col sm={12}>
                        <Link to={`/self-assessments/${selectedChildId}/${item.formId}`} style={{ textDecoration: 'none' }} key={item.formId}>
                            <Card style={{ marginBottom: 20 }}>
                                <Label className='pull-right' bsStyle={color} style={{ lineHeight: 1.5 }}>
                                    <FontAwesome name={icon} /> {t(`FormStatus_${item.status}`)}
                                </Label>
                                <h4 style={{ textTransform: 'none', lineHeight: 1.5, color: '#2E5BFF' }}>
                                    <FontAwesome name={'play'} style={{ marginRight: 5 }} />{t(`AssessmentForm_SelfAssessment_${item.name}`)}
                                </h4>
                                <div className='text-muted'>
                                    {t('FO_IndividualConsultationForm_Modified')} <b style={{ color: '#1c9979' }}>{moment(item.modified).format('lll')}</b>
                                </div>
                            </Card>
                        </Link>
                    </Col>;
                })}
            </Row>
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const { parent: { children }, entities: { selfAssessments }, lookups: { selfAssessmentForms }, configuration: { franchisor } } = state;

    const { childId } = ownProps.match.params;

    return {
        selfAssessments: Object.values(selfAssessments),
        children,
        hasChildren: children.length > 0,
        selfAssessmentForms,
        childId: childId && Number(childId),
        requireChildLastName: franchisor && franchisor.requireChildLastName,
        enableParentSelfBooking: franchisor && franchisor.enableParentSelfBooking,
        hasSameAsParentChild: hasSameAsParentChild(state.parent)
    };
};

export default connect(mapStateToProps, {
    loadSelfAssessments,
    createChild
})(withNamespaces()(SelfAssessments));